import { LinkButton, PlainButton } from "@digipost/dds-buttons-react";
import { useLanguage } from "@digipost/translate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import React, { FC, useState } from "react";
import { Link, useLocation } from "react-router";

import Translated from "../infrastructure/components/Translated";
import { LanguageLinks } from "../infrastructure/hooks/translate";
import { useRootPath } from "../infrastructure/hooks/useRootPath";
import styles from "./Header.module.less";
import Logo from "./Logo";

const Header: FC<{
  isActive: boolean;
  onShow: React.MouseEventHandler<HTMLButtonElement>;
}> = ({ isActive, onShow }): React.ReactElement => {
  const [showLanguageMenu, setShowLanguangeMenu] = useState(false);
  const location = useLocation();
  const rootPath = useRootPath();
  const { language } = useLanguage();

  const HamburgerMenuOpener = (): React.ReactElement => {
    return (
      <PlainButton
        className={classNames(styles.mobilemenuOpener, {
          [styles.open]: isActive,
        })}
        onClick={onShow}
      >
        <span className={"visuallyhidden"}>
          <Translated textKey={"menu.accessible_description"} />
        </span>
        <FontAwesomeIcon
          className={styles.mobilemenuIcon}
          icon={["far", isActive ? "xmark" : "bars"]}
        />
      </PlainButton>
    );
  };

  const logoutPage = location.pathname.includes("logout");
  const businessPage = location.pathname.includes("business");
  const emailVerificationPage =
    location.pathname.includes("epost-verifisering");
  const showPrivateLoginButton = businessPage || emailVerificationPage;

  return (
    <header className={styles.header}>
      <Logo />
      <div className={styles.headerItemsContainer}>
        <LinkButton
          className={styles.headerItem}
          as="a"
          href={"/" + (language === "nb" ? "" : language)}
        >
          <Translated textKey="generic.to_front_page" />
        </LinkButton>
        {!logoutPage &&
          (showPrivateLoginButton ? (
            <LinkButton
              className={styles.headerItem}
              as={Link}
              to={`${rootPath}/`}
            >
              <Translated textKey="login.header_to_private" />
            </LinkButton>
          ) : (
            <LinkButton
              className={styles.headerItem}
              as={Link}
              to={`${rootPath}/business`}
            >
              <Translated textKey="login.header_to_org" />
            </LinkButton>
          ))}
        <LinkButton
          onClick={() => setShowLanguangeMenu((prevState) => !prevState)}
          className={styles.headerItem}
        >
          <Translated textKey="login.header_langauge" />
        </LinkButton>
      </div>
      {showLanguageMenu && (
        <div className={styles.headerLanguageMenu}>
          <ul className={styles.headerLanguageList}>
            <LanguageLinks style={styles.headerLanguageLink} />
          </ul>
        </div>
      )}
      <div className={styles.headerMobileVersion}>
        <HamburgerMenuOpener />
      </div>
    </header>
  );
};

export default Header;
